import { useState, useEffect } from "react";
import { sweetAlertHelper } from "../../../helper/sweetalert.helper";
import moment from "moment";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";

//formik
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ref } from "yup";

//element component
import Button from "../../../components/element/button";
import Input from "../../../components/element/input";
import Select from "../../../components/element/select";
import apiServices from "../../../services/api.services";

export default function CreateModalBox({
  title,
  show,
  values,
  close,
  disabled,
  getListing,
}) {
  const [data, setData] = useState({
    username: "",
    phone_number: "",
    roles_id: "",
    password: "",
    confirm_password: "",
  });

  const useSchema = Yup.object({
    username: Yup.string()
      .required("Please enter your username")
      .email("Invalid Email Address Format"),
    phone_number: Yup.string()
      .required("required")
      .min(10, "Please enter more than or equal to 10 character")
      .max(13, "Must be exactly 13 digits")
      .matches(/^([6]{1}|\+?[0]{1})([0-9]{9,11})$/g, "Must be phone format"),
    roles_id: Yup.string().required("Please enter your roles id"),
    password: Yup.string().required("Please enter your password"),
    confirm_password: Yup.string()
      .required("Please confirm your password")
      .oneOf([ref("password")], "Passwords do not match"),
    frist_name: Yup.string(),
    last_name: Yup.string(),
  });

  const handleSubmit = async (values, setFieldError, type) => {
    try {
      const response = await apiServices.createUser({
        type: "other",
        payload: values,
      });
      if (response) {
        sweetAlertHelper({
          title: "Success",
          text: "Create  Success",
          icon: "success",
        });
        close(false);
        getListing();
      }
    } catch (ex) {
      if (ex && Object.keys(ex).length > 0) {
        if (ex.response.status === 422) {
          const errors = ex.response.data.errors;
          if (errors && Object.keys(errors).length > 0) {
            Object.keys(errors).map((item, i) => {
              setFieldError(item, errors[item]);
            });
          }
        }
      }
    }
  };

  const [roleList, setRoleList] = useState([]);

  const getRoleListing = async () => {
    const response = await apiServices.getRoleListing();
    if (response) {
      setRoleList(response);
    }
  };

  useEffect(() => {
    getRoleListing();
  }, []);

  return (
    <MDBModal staticBackdrop tabIndex="-1" show={show}>
      <MDBModalDialog>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>{title}</MDBModalTitle>
            <MDBBtn
              className="btn-close"
              color="none"
              onClick={() => close((prevState) => !prevState)}
            ></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <Formik
              enableReinitialize={true}
              validateOnChange={true}
              initialValues={data}
              validationSchema={useSchema}
              onSubmit={(
                values,
                { setFieldError, resetForm, setSubmitting }
              ) => {
                handleSubmit(values, setFieldError);
                // resetForm({ values: ""})
              }}
            >
              {({ handleReset, errors }) => (
                <Form className="modal-form">
                  <Input label="User Name" name="username" />
                  <Input label="Phone Number" name="phone_number" />
                  <Select
                    name="roles_id"
                    label="Role"
                    options={[
                      { id: 10, label: "Housekeeping" },
                      { id: 9, label: "Maintenance" },
                      { id: 17, label: "Frontdesk" },
                      { id: 13, label: "F&B" },
                      { id: 12, label: "Finance" },
                      { id: 15, label: "marketing" },
                      { id: 11, label: "Admin" },
                    ]}
                    placeholder="- Please Select -"
                    errors={errors}
                  />
                  <Input label="Password" name="password" type="password" />
                  <Input
                    label="Confirm Password"
                    name="confirm_password"
                    type="password"
                  />

                  <Button name="Submit" />
                </Form>
              )}
            </Formik>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}
